import request, { METHODS } from "src/utils/api-base";

const supportRequestApis = {
  createSupportRequest: (payload: {
    name: string;
    email: string;
    mobile: string;
    message: string;
  }) => {
    return request({
      route: "/app/support-request/create",
      method: METHODS.POST,
      payload,
    });
  },
  getSupportRequestsListAdmin: (params: {
    page: number;
    limit: number;
    status?: string;
    search?: string;
  }) => {
    return request({
      route: "/admin/support-request/list",
      method: METHODS.GET,
      params,
      auth: true,
      isAdminAuth: true,
    });
  },
  getSupportRequestsListTenant: (params: {
    page: number;
    limit: number;
    status?: string;
    search?: string;
  }) => {
    return request({
      route: "/app/support-request/list",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },
  updateSupportRequestStatusAdmin: (payload: {
    _id: string;
    status: string;
  }) => {
    const { _id, status } = payload;
    return request({
      route: `/admin/support-request/${_id}/status`,
      method: METHODS.PATCH,
      payload: { status },
      auth: true,
      isAdminAuth: true,
    });
  },
};

export default supportRequestApis;
